import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

interface AlertProps {
	title: string;
	message: string[];
	isOpen: boolean;
	leftButtonMessage?: string;
	leftButtonAction?: () => void;
	rightButtonMessage: React.ReactNode;
	rightButtonAction: () => void;
	keepOpen?: boolean;
}

const AlertDialog: React.FC<AlertProps> = ({
	title,
	message,
	isOpen,
	leftButtonMessage,
	leftButtonAction,
	rightButtonMessage,
	rightButtonAction,
	keepOpen,
}) => {
	const handleClose = () => {
		if (!keepOpen) {
			rightButtonAction();
		}
	};

	return (
		<Dialog data-testid="alert-dialog" open={isOpen} onClose={handleClose} closeAfterTransition={false}>
			<DialogTitle data-testid="alert-title">{title}</DialogTitle>
			<DialogContent>
				{message.map((msg, i) => {
					return (
						<DialogContentText data-testid="alert-content-text" key={`msg-${i}`} textAlign={'center'} gutterBottom={true}>
							{msg}
						</DialogContentText>
					);
				})}
			</DialogContent>
			<DialogActions>
				{leftButtonAction && leftButtonMessage && (
					<Button data-testid="alert-dialog-left-button" onClick={() => leftButtonAction()}>
						{leftButtonMessage}
					</Button>
				)}
				<Button data-testid="alert-dialog-right-button" onClick={() => rightButtonAction()}>
					{rightButtonMessage}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AlertDialog;
